<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import type { ButtonVariants } from '.'

import { Primitive } from 'reka-ui'

import { buttonVariants } from '.'
import { cn } from '../../../lib/utils'

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  class?: HTMLAttributes['class']
  onClick?: (e: MouseEvent) => void
}

const props = withDefaults(defineProps<Props>(), {
  as: 'button',
})
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    data-slot="button"
    :data-variant="variant || 'default'"
    :data-size="size || 'default'"
    :class="cn(buttonVariants({ variant, size }), props.class)"
    @click="props.onClick"
  >
    <slot />
  </Primitive>
</template>
